/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptReferenceMeasurementDto
 */
export interface AcceptReferenceMeasurementDto {
    /**
     * 
     * @type {string}
     * @memberof AcceptReferenceMeasurementDto
     */
    measurementId?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptReferenceMeasurementDto
     */
    $type?: AcceptReferenceMeasurementDtoTypeEnum;
}


/**
 * @export
 */
export const AcceptReferenceMeasurementDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoAcceptReferenceMeasurementDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.AcceptReferenceMeasurementDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type AcceptReferenceMeasurementDtoTypeEnum = typeof AcceptReferenceMeasurementDtoTypeEnum[keyof typeof AcceptReferenceMeasurementDtoTypeEnum];


/**
 * Check if a given object implements the AcceptReferenceMeasurementDto interface.
 */
export function instanceOfAcceptReferenceMeasurementDto(value?: unknown): value is AcceptReferenceMeasurementDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AcceptReferenceMeasurementDtoTypeEnum)[0];
}

export function AcceptReferenceMeasurementDtoFromJSON(json: any): AcceptReferenceMeasurementDto {
    return AcceptReferenceMeasurementDtoFromJSONTyped(json, false);
}

export function AcceptReferenceMeasurementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptReferenceMeasurementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurementId': !exists(json, 'measurementId') ? undefined : json['measurementId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function AcceptReferenceMeasurementDtoToJSON(value?: AcceptReferenceMeasurementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'measurementId': value.measurementId,
        '$type': value.$type,
    });
}

